import IConsentTemplate, { IConsentTemplateTranslation } from './consent-template.model';

export default class ConsentTemplateApiModel {
  public id!: string;
  public swedishTranslations!: IConsentTemplateTranslation;
  public englishTranslations!: IConsentTemplateTranslation;
  public static mapToBusinessModel(apiModel: ConsentTemplateApiModel): IConsentTemplate {
    return {
      id: apiModel.id,
      swedishTranslations: apiModel.swedishTranslations,
      englishTranslations: apiModel.englishTranslations,
    };
  }
}
